import { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { errorKeyOf } from '../lib/errorKey';
import { toastError } from '../shell/toastStore';

export type RunResult<T> = { readonly ok: true; readonly value: T } | { readonly ok: false };
export type RunCommand = <T>(operation: () => Promise<T>) => Promise<RunResult<T>>;

/** Runs a store command; a failure becomes an error toast and `{ ok: false }` instead of an exception. */
export function useRunCommand(): RunCommand {
  const { t } = useTranslation();
  return useCallback(
    async <T>(operation: () => Promise<T>): Promise<RunResult<T>> => {
      try {
        return { ok: true, value: await operation() };
      } catch (error) {
        toastError(t(errorKeyOf(error)));
        return { ok: false };
      }
    },
    [t],
  );
}
